const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Profile+Full+Information


function getProfileFullInformation(profileId, options) {

    let url = `/api/users/profiles/${profileId}/full`;

    let { skipApis,
        includeApis,
        includeTargeters,
        productId,
        preferedSku,
        propertiesToInclude } = options;

    let qsParams = {
        skipApis,
        includeApis,
        includeTargeters,
        productId,
        preferedSku,
        propertiesToInclude
    };

    let qs = urlUtils.makeQueryString(qsParams);

    if (qs) {
        url += '?' + qs;
    }

    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getProfileFullInformation;
